let slider_preview;

$(function () {
	counter_init();
	product_slider_init();
	product_slider_events();
	catalog_arrow_check();
	basket_stock_calc()

	roll_change();
	catalogFilterInit()

	$(document).on('click', '.price-type-val', (e) => {
		let self = $(e.currentTarget),
			block = self.closest(".price-block"),
			type = self.attr('data-type')

		block.find(".price-block-val__itm").removeClass("active");
		block.find(`.price-block-val__itm[data-type='${type}']`).addClass("active");

		block.find('.price-type-val').removeClass("active");
		self.addClass('active');

		roll_change();
	});

	$(document).on('click', ".catalog-slider__preview__img", (e) => {
		let self = $(e.currentTarget),
			image = self.attr('data-image-detail')

		$('.catalog-slider__img img').attr('src', image);
	});


	$(".owl-item:not(.cloned) [data-fancybox]").fancybox({
		loop: false,
		animationEffect: "fade",
	});


	$(document).on('click', ".catalog-slider__img", (e) => {
		let self = $(e.currentTarget),
			src = self.find('img').attr('src'),
			preview = $(`.owl-item:not(.cloned) .catalog-slider__preview__img[data-image-detail="${src}"]`)

		preview.find('a').first().trigger("click.fb-start", {$trigger: preview.find('a').first()});
	});

	$(window).on('scroll', (e) => {
		let scroll = $(window).scrollTop(),
			offset = $('.header').height() + $('.catalog-nav').height()

		catalog_arrow_check();

		$('.js-scroll-section').each((i, itm) => {
			let top = $(itm).offset().top,
				bot = top + $(itm).height()

			if (scroll > top - offset - 40 && scroll < bot) {
				const id = $(itm).attr('id'),
					active = $(`.catalog-nav-itm[href="#${id}"]`)
				let left = 0

				if (active.parent().prevAll().length > 0) {
					$('.catalog-nav').addClass("show-product");
				} else {
					$('.catalog-nav').removeClass("show-product");
				}

				active.parent().prevAll().each((i, itm) => {
					left += parseInt($(itm).outerWidth(true))
				})

				if (!active.hasClass('active')) {
					$('.catalog-nav').stop()
					$('.catalog-nav').animate({scrollLeft: left}, 600);
				}

				$('.catalog-nav-itm').removeClass("active")
				active.addClass("active")


			}

		})

	});

	$(document).on('click', '.js-change-calc-type', (e) => {
		let self = $(e.currentTarget),
			type = self.attr('data-type')

		$('.modal-calc').removeClass("show-area show-size").addClass(`show-${type}`);
	});

	$('#modal-calc input[type="number"]').on('input', (e) => {
		let self = $(e.currentTarget),
			val = parseInt(self.val())

		if (val < 0) val = 0;

		self.val(val);
	});

	$('.js-form-calc').on('submit', (e) => {
		let form = $(e.currentTarget),
			modal = $('#modal-calc'),
			type = form.find('[name="type"]:checked'),
			type_k = parseFloat(type.attr('data-type-k')),
			area = form.find('[name="area"]'),
			width = form.find('[name="width"]'),
			height = form.find('[name="height"]'),
			show = form.closest('.modal-calc').hasClass('show-area'),
			m2_in_pack = parseFloat(modal.find('[name="m2-in-pack"]').val()),
			price = parseFloat(modal.find('[name="price"]').val()),
			stock = parseInt(modal.find('[name="stock"]').val()),
			pack_count = 0,
			square = 0

		if (show) {
			if (area.val().length === 0) {
				area.closest('.input').addClass('error');
				return false;
			}
		} else {
			if (width.val().length === 0) {
				width.closest('.input').addClass('error');
				return false;
			}
			if (height.val().length === 0) {
				height.closest('.input').addClass('error');
				return false;
			}
		}

		if ($('.modal-calc').hasClass('show-size')) {
			square = parseInt(width.val() * height.val())
		} else {
			square = parseInt(area.val())
		}

		square = toDec2(square * type_k);

		pack_count = Math.ceil(square / m2_in_pack)


		if (type.length === 0) {
			$('.calc-cart').addClass("error");

			return false;
		}


		$('.js-counter-calc-block').removeClass("error");


		$('.js-calc-pack-val').text(`${pack_count}`)


		$('.js-calc-width-val').text(`${width.val()} м`)
		$('.js-calc-height-val').text(`${height.val()} м`)
		$('.js-calc-area-val').text(`${area.val()} м`)

		$('.js-calc-type-val').text(`${type.val()}`)


		if (pack_count > stock) {
			$('.js-counter-calc-block').addClass("error");
			pack_count = stock;
		}

		$('.js-calc-total-square').text(toDec2(pack_count * m2_in_pack))
		modal.find('.add-cart-counter__input').val(pack_count)
		modal.find('.js-counter-bitrix').val(pack_count)
		modal.find('.js-calc-total-price').text(XFormatPrice(price * pack_count))


		form.slideUp()
		form.next('.calc-result').slideDown()

		return false;
	});

	$('.js-calc-to-card').on('click', (e) => {
		let self = $(e.currentTarget)

		$('.calc-result-table__foot__action').addClass("to-card");
		$('.calc-result').addClass("to-card");

		//Установка стостояния в кнопку на странице
		let count = self.closest('.calc-result').find('.js-counter-bitrix').val(),
			block = $('.catalog-info')

		block.find('.js-counter-bitrix,.add-cart-counter__input').val(count)
		block.find('.js-counter-btn-value').text(count)
		block.find('.add-cart-btn').addClass("show-counter")
	});

	$('.calc-result .add-cart-counter__input').on('input', (e) => calc_result_change())
	$('.calc-result .js-counter-btn').on('click', (e) => calc_result_change())


	$('.calc-cart input').on('input', (e) => {
		$('.calc-cart').removeClass("error");
	})

	$('.js-calc-back').on('click', (e) => {
		let form = $(e.currentTarget).closest('.calc-result')

		form.slideUp()
		form.prev('.js-form-calc').slideDown()
		$('.calc-result-table__foot__action').removeClass("to-card");
		$('.calc-result').removeClass("to-card");

		return false;
	});

	$('.roll-width input').on('change', (e) => {
		let val = $(e.currentTarget).val()

		$('.roll-width').removeClass("error");

		$('.js-roll-width').text(val)

		roll_change()
	})

	$('.radio-tab-head input').on('change', (e) => {
		let self = $(e.currentTarget),
			block = self.closest('.radio-tab')

		block.find('.js-show-radio-tab').addClass("hide");

		block.find(`[data-show-for="${self.val()}"]`).closest('.input').removeClass('hide');
	});

	$('.js-open-buy-one-click-modal').on('click', (e) => {
		let self = $(e.currentTarget),
			product_id = self.attr('data-product-id'),
			modal = $('#modal-buy-one-click'),
			count = 1,
			name = "",
			sku = "",
			price = 1,
			stock = 1

		modal.find('[name="product_id"]').val(product_id)


		if (self.closest('#modal-calc').length > 0) {
			let parent = self.closest('#modal-calc');

			count = parent.find(".add-cart-counter__input").val()
			name = parent.find('.calc-list-itm__title').text()
			sku = parent.find('.calc-list-itm__sku').text()
			price = parseFloat(parent.find('[name="price"]').val())
			stock = parent.find('[name="stock"]').val()
		} else {
			name = $('.catalog-info__title').text()
			sku = self.attr('data-sku')
			price = parseFloat(self.attr('data-price'))
			stock = self.attr('data-stock')
		}

		modal.find('[name="price"]').val(price)
		modal.find('[name="product_name"]').val(name)

		modal.find('.js-sku-val').text(sku)
		modal.find('.basket-itm__name').text(name)
		modal.find('.js-one-click-price-total').text(XFormatPrice(count * price))
		modal.find('.js-one-click-price-pack').text(XFormatPrice(price))
		modal.find('.add-cart-counter__input').val(count)
		modal.find('.add-cart-counter__input').attr('data-max-count', stock)

		open_modal('#modal-buy-one-click')
	});

	$('#modal-buy-one-click .add-cart-counter__input').on('input', modal_buy_one_click_counter);
	$('#modal-buy-one-click .js-counter-btn').on('click', modal_buy_one_click_counter);

})

$('.basket-btn').on('click', (e) => {
	if ($('.out-of-stock').length > 0) {
		$('body,html').animate({
			scrollTop: $('.out-of-stock').first().closest('.basket-itm').offset().top - $('.header').outerHeight(true)
		}, 600)
		return false;
	}
})

const basket_stock_calc = () => {
	let count = $('.out-of-stock').length

	if (count === 0) {
		$('.basket-alert').addClass("hide")
		$('.basket-btn').removeClass("disabled")
		$('.js-out-of-stock-today').closest(".basket-total-attr").addClass("hide")
	} else {
		$('.basket-alert').removeClass("hide")
		$('.basket-btn').addClass("disabled")
		$('.js-out-of-stock-today').closest(".basket-total-attr").removeClass("hide")
	}

	$('.js-out-of-stock-today').text(count)

	$('.basket-alert__text__val').text(count + " " + num_word(count, ['товар', 'товара', 'товаров']))
}

const modal_buy_one_click_counter = () => {
	setTimeout(() => {
		let modal = $('#modal-buy-one-click'),
			val = parseInt($('#modal-buy-one-click .add-cart-counter__input').val()),
			price = parseFloat(modal.find('[name="price"]').val())

		modal.find('.js-one-click-price-total').text(XFormatPrice(val * price))
		modal.find('.js-one-click-price-pack').text(XFormatPrice(price))
	}, 0)
}

const calc_result_change = () => {
	//Чтобы успел отработать функционал изменения числа
	setTimeout(() => {
		let modal = $('#modal-calc'),
			input = modal.find('.add-cart-counter__input'),
			pack_count = parseInt(input.val()),
			m2_in_pack = parseFloat(modal.find('[name="m2-in-pack"]').val()),
			price = parseFloat(modal.find('[name="price"]').val()),
			square = pack_count * m2_in_pack

		$('.js-counter-calc-block').removeClass("error");

		modal.find('.js-calc-total-price').text(XFormatPrice(price * pack_count))
		$('.js-calc-total-square').text(toDec2(square))
	}, 0)
}

const toDec2 = (num) => {
	return Math.round(num * 100) / 100
}

const catalog_arrow_check = () => {
	let scroll = $(window).scrollTop()

	if (scroll > 1500) {
		$('.arrow-top').removeClass("arrow-top--hide");
	} else {
		$('.arrow-top').addClass("arrow-top--hide");
	}
}

const counter_init = () => {
	$(document).on('click', ".js-add-cart", (e) => {
		let self = $(e.currentTarget),
			roll_width = $('[name="roll-width"]'),
			input = self.parent().find(".add-cart-counter__input"),
			input_bitrix = input.siblings('.js-counter-bitrix'),
			step = parseFloat(input.attr('data-step')) || 1

		if (roll_width.length > 0 && $('[name="roll-width"]:checked').length === 0) {
			$('.roll-width').addClass("error");
			e.stopImmediatePropagation();
			return false;
		}

		self.parent().addClass("show-counter");
		input_bitrix.val(step);

		roll_change();


		let calc_val = countBitrixValueToShow(input_bitrix, input)
		input.val(calc_val)

		input.closest('.add-cart-counter').find('.js-counter-btn-value').text(calc_val)

		let prodId = parseInt(self.data('prod-id'));
		let cartAddUrl = self.data('url');
		addToCard(self, prodId, cartAddUrl)
	});

	$(document).on('click', ".catalog-main-roll .js-add-cart", (e) => {
		$('.roll-calc-wrap').slideDown();
	});

	$(document).on('click', ".js-counter-btn", (e) => {
		let self = $(e.currentTarget),
			input_bitrix = self.siblings('.js-counter-bitrix'),
			direction = self.attr("data-direction"),
			input = self.siblings('.add-cart-counter__input'),
			step = parseFloat(input_bitrix.attr('data-step')) || 1,
			num = parseFloat(input_bitrix.val()),
			max_count = parseFloat(input_bitrix.attr('data-max-count')),
			stock_count = parseFloat(input_bitrix.attr('data-stock-count')),
			is_basket = self.closest(".basket-itm").length > 0 && self.closest("#modal-wait-list").length === 0,
			is_modal_calc = self.closest(".modal-calc").length > 0


		input.siblings('.js-counter-btn').removeClass("disabled");
		input.closest('.js-counter-calc-block').removeClass("error");


		if (!max_count) max_count = 999;
		max_count = Math.floor(max_count / step) * step
		if (!is_basket) {
			num = direction === "plus" ? num + step : num - step;
		}

		if (stock_count) {
			max_count = stock_count;
		}

		let num_min = is_basket || is_modal_calc ? step : 0;
		if (num < num_min) num = num_min;
		if (num >= max_count) {
			input.siblings('.plus.js-counter-btn').addClass("disabled");
			num = max_count;
			input.closest('.js-counter-calc-block').addClass("error");
		}


		if (stock_count) {
			if (num > stock_count) {
				input.closest('.add-cart-counter').addClass("out-of-stock")
			} else {
				input.closest('.add-cart-counter').removeClass("out-of-stock")
			}
			basket_stock_calc()
		}

		input_bitrix.val(num)

		if (num === 0) {
			self.closest(".add-cart-btn").removeClass("show-counter");
			$('.roll-calc-wrap').slideUp();
		}

		let calc_val = countBitrixValueToShow(input_bitrix, input)

		input.val(calc_val)
		self.parent().find('.js-counter-btn-value').text(calc_val)

		//Устанавливаем значение в скрытый инпут для форсы "узнать о поступлении"
		let count_target = self.closest('#modal-wait-list').find('[name="form_hidden_37"]')
		if (count_target.length > 0) {
			count_target.val(self.closest('#modal-wait-list').find('.add-cart-counter__text').text().trim())
		}

		let basket_itm = input.closest(".basket-itm")
		if (basket_itm) basket_calc(basket_itm)


		let prodId = parseInt(self.data('prod-id'));
		let cartAddUrl = self.data('url');

		addToCard(self, prodId, cartAddUrl, "changeProductCount")

		if (is_modal_calc) {
			$('.calc-result-table__foot__action').removeClass("to-card")
		}
	});

	$(document).on('click', '.add-cart-counter__text', (e) => {
		let self = $(e.currentTarget),
			block = self.closest('.add-cart-counter')

		block.addClass('add-cart-counter--input')
		block.find('.add-cart-counter__input').focus()

	})

	$(document).on('change', '.add-cart-counter__input', (e) => {
		let input = $(e.currentTarget),
			num = parseFloat(input.val())

		if (num === 0 || input.val() === "") {
			input.closest(".add-cart-btn").removeClass("show-counter");
			$('.roll-calc-wrap').slideUp();
		}
	});

	$(document).on('blur', '.add-cart-counter__input', (e) => {
		let input = $(e.target),
			block = input.closest('.add-cart-counter'),
			input_bitrix = input.siblings('.js-counter-bitrix'),
			roll_width = parseFloat(input_bitrix.attr('data-roll-width')),
			step = parseFloat(input_bitrix.attr('data-step')) || 1,
			max_count = parseFloat(input_bitrix.attr('data-max-count')),
			stock_count = parseFloat(input_bitrix.attr('data-stock-count')),
			val = countBitrixValueToHide(input_bitrix, input),
			is_basket = input.closest(".basket-itm").length > 0

		if (!val) val = is_basket ? step : 0;

		let num_min = is_basket ? step : 0
		if (val < 0) {
			val = num_min;
		}

		val = Math.ceil(val / step) * step


		if (stock_count) {
			max_count = stock_count;
			input.closest('.add-cart-counter').removeClass("out-of-stock")
		}

		if (!max_count) max_count = 999;

		if (val > max_count) val = max_count


		block.removeClass("add-cart-counter--input")

		input_bitrix.val(val)

		let calc_val = countBitrixValueToShow(input_bitrix, input)

		block.find('.js-counter-btn-value').text(calc_val)
		input.val(calc_val)

		//Устанавливаем значение в скрытый инпут для форсы "узнать о поступлении"
		let count_target = block.closest('#modal-wait-list').find('[name="form_hidden_37"]')
		if (count_target.length > 0) {
			count_target.val(block.closest('#modal-wait-list').find('.add-cart-counter__text').text().trim())
		}

		roll_change()
		basket_stock_calc()

		let basket_itm = input.closest(".basket-itm")
		if (basket_itm) basket_calc(basket_itm)

		input_bitrix[0].dispatchEvent(new Event('change'));


	})

	$(document).on('input', '.add-cart-counter__input', (e) => {
		let input = $(e.currentTarget),
			input_bitrix = input.siblings('.js-counter-bitrix'),
			step = parseFloat(input_bitrix.attr('data-step')) || 1,
			max_count = parseFloat(input_bitrix.attr('data-max-count')),
			stock_count = parseFloat(input_bitrix.attr('data-stock-count')),
			num = countBitrixValueToHide(input_bitrix, input);

		input_bitrix.val(countBitrixValueToHide(input_bitrix, input))


		input.siblings('.js-counter-btn').removeClass("disabled");
		input.closest('.js-counter-calc-block').removeClass("error");


		if (!max_count) max_count = 999;

		if (stock_count) {
			max_count = stock_count;

			if (num < stock_count) {
				input.closest('.add-cart-counter').removeClass("out-of-stock")
			} else {
				input.closest('.add-cart-counter').addClass("out-of-stock")
			}
			basket_stock_calc()
		}

		if (!num) num = 0;
		if (num < 0) num = 0;
		if (num >= max_count) {
			num = max_count;
			input.siblings('.plus.js-counter-btn').addClass("disabled");
			input.closest('.js-counter-calc-block').addClass("error");
		}


		if (num === 0) {
			input.val("")
			return;
		}

		input_bitrix.val(num)

		//input.val(countBitrixValueToShow(input_bitrix, input))


		let basket_itm = input.closest(".basket-itm")
		if (basket_itm) basket_calc(basket_itm)
	});

	$(document).on('click', ".js-catalog-roll-btns .js-counter-btn", (e) => roll_change());
	$(document).on('input', ".js-catalog-roll-btns .add-cart-counter__input", (e) => roll_change());


	$('.basket-itm').each((k, i) => {
		basket_calc($(i))
	})

	$('.add-cart-counter').each((k, i) => {
		let block = $(i),
			input = block.find('.js-counter-bitrix')

		if (parseFloat(input.val()) >= parseFloat(input.attr('data-stock-count'))) {
			block.find('.plus.js-counter-btn').addClass("disabled")
		}
	})

	const countBitrixValueToHide = (input_hide, input_show) => {
		let show_val = parseFloat(input_show.val()),
			type = input_hide.attr('data-product-type'),
			roll_width = parseFloat(input_hide.attr('data-roll-width'))

		if (!type && !roll_width) return show_val

		let calc_val = Math.ceil(show_val / roll_width)

		return calc_val
	}

	const countBitrixValueToShow = (input_hide, input_show) => {
		let hide_val = parseFloat(input_hide.val()),
			type = input_hide.attr('data-product-type'),
			roll_width = parseFloat(input_hide.attr('data-roll-width'))

		if (!type && !roll_width) return hide_val

		let calc_val = hide_val * roll_width

		return calc_val
	}
}

const basket_calc = (itm) => {
	const type = itm.find('[name="type"]').val()

	if (!type) return false;


	let val = parseFloat(itm.find('.add-cart-counter__input').val()),
		m2_in_pack = parseFloat(itm.find('[name="m2-in-pack"]').val()),
		m2_in_roll = parseFloat(itm.find('[name="m2-in-roll"]').val()),
		m2 = 0, pack_count = 0, cut = 0, roll = 0

	if (!val) val = 0;

	switch (type) {
		case 'pack':
			pack_count = val
			m2 = pack_count * m2_in_pack
			break;
		case 'roll+cut':
			m2 = val
			roll = Math.floor(m2 / m2_in_roll)
			cut = m2 - (roll * m2_in_roll)

			itm.find('.js-basket-has-roll').toggle(roll > 0);
			itm.find('.js-basket-has-cut').toggle(cut > 0);
			itm.find('.js-basket-has-roll-and-cut').toggle(cut > 0 && roll > 0);
			break;
		case 'roll':
			m2 = val
			roll = Math.floor(m2 / m2_in_roll)
			break;
	}

	itm.find('.js-basket-val-roll').text(roll + " " + num_word(roll, ['рулон', 'рулона', 'рулонов']))
	itm.find('.js-basket-val-cut').text(cut)
	itm.find('.js-basket-val-count').text(val)
	itm.find('.js-basket-val-m2').text(m2.toFixed(1))

}

const addToCard = (self, prodId, cartAddUrl, action = "addProduct") => {
	if (!prodId) return;

	setTimeout(() => {
		let cnt = self.closest(".add-cart-counter").find('.js-counter-bitrix').val()

		if (self.hasClass('js-add-cart')) {
			cnt = self.siblings(".add-cart-counter").find(".js-counter-bitrix").val()
		}
		if (action === 'addProductFromCalc') {
			cnt = self.closest(".calc-result-table__foot").siblings(".calc-result-table").find(".js-counter-bitrix").val()
		}

		$.ajax({
			url: cartAddUrl,
			method: 'post',
			dataType: 'json',
			data: {
				'count': cnt,
				'productId': prodId,
				'action': action
			},
			success: function (obj) {
				if (obj.hasError) {
					//alert('Ошибка добавления товара в корзину');
					//return false;
				}
				if (cnt == 1 && action === 'removeProduct') self.closest(".show-counter").removeClass("show-counter")

				updateHeaderBasket()
			},
			error: function (p1, p2, p3) {
				console.log(p1, p2, p3);
			}
		});
	}, 0)
}


const roll_change = () => {
	if ($('.roll-calc').length === 0) return;
	setTimeout(() => {
		let num = parseFloat($('.js-catalog-roll-btns .add-cart-counter__input').val()),
			price = parseFloat($('[name="price-m2"]').val()),
			roll_width = parseFloat($('[name="roll-width"]:checked').val()),
			m2_total = num,
			m_total = m2_total / roll_width,
			m2_in_roll = parseFloat($('[name="m2-in-roll"]').val())

		if (!num) {
			num = 0;
			m2_total = 0;
			m_total = 0;
		}

		if ($('.price-type-val[data-type="m"].active').length > 0) {
			//Активны погонные метры
			m_total = num
			m2_total = num * roll_width;
		}

		if (m2_in_roll) {
			let buy_type = $('[name="buy-type"]').val();

			let roll_count = buy_type !== 'roll' ? Math.floor(m2_total / m2_in_roll) : Math.ceil(m2_total / m2_in_roll);


			if ($('.price-type-val[data-type="roll"].active').length > 0) {
				roll_count = m2_total
			}

			m_total = buy_type !== 'roll' ? m2_total % m2_in_roll / roll_width : roll_count * m2_in_roll

			if (buy_type === 'roll') {
				m2_total = roll_count * m2_in_roll
			}

			if (roll_count <= 0) {
				$('.js-buy-roll-col').addClass("v-hide")
			} else {
				$('.js-buy-roll-col').removeClass("v-hide")
			}

			if (m_total === 0) {
				$('.js-calc-img-cut').addClass("hide")
				$('.js-calc-img-full').removeClass("hide")
			} else {
				$('.js-calc-img-cut').removeClass("hide")
				$('.js-calc-img-full').addClass("hide")
			}

			let m2_total_roll = roll_count * m2_in_roll
			let m2_total_cut = m2_total - m2_total_roll

			$('.js-roll-count').text(roll_count);
			$('.js-catalog-m2-total-cut').text(m2_total_cut);
			$('.js-catalog-m2-total-roll').text(m2_total_roll);
		}


		let width = calcRollWidth(m_total);

		$('.roll-calc-img-move').css('width', `${width}rem`)

		$('.js-catalog-m-total').text(numRound(m_total))
		$('.js-catalog-m2-total').text(numRound(m2_total))
		$('.js-catalog-price-total').text(priceFormat(m2_total * price))
	}, 0)
}

const product_slider_events = () => {
	$(document).on('mousemove', '.product-itm-images', function (e) {
		if (is_tablet) return false;

		var width = $(this).outerWidth(),
			x = e.clientX - $(this).offset().left,
			items = $(this).find('.product-itm-images__itm'),
			length = items.length - 1,
			part_width = width / length,
			num = Math.round(x / part_width);

		slider_move_to($(this), num)
	});


	$(window).on('resize', () => {
		product_slider_resize();
	})

	$('.product-slider').owlCarousel({
		items: 4,
		margin: 24,
		dots: false,
		nav: true,
		mouseDrag: false,
		responsive: {
			0: {items: 2, margin: 16},
			600: {items: 2, margin: 24},
			1100: {items: 4, margin: 24}
		},
	})

	$('.product-slider-lk').owlCarousel({
		items: 3,
		margin: 24,
		dots: false,
		nav: true,
		responsive: {
			0: {items: 2, margin: 16},
			600: {items: 2, margin: 24},
			1100: {items: 3, margin: 24}
		},
	})

	if (is_tablet) {
		$('.blog-grid').owlCarousel({
			items: 4,
			margin: 24,
			dots: false,
			nav: true,
			responsive: {
				0: {items: 1, margin: 16},
				600: {items: 2, margin: 24},
				1100: {items: 4, margin: 0}
			},
		})
	}

}

const slider_move_to = (slider, num) => {
	const width = slider.outerWidth(true),
		stage = slider.find('.product-itm-images-stage')

	slider.attr('data-page', num)
	stage.css('transform', `translateX(-${num * width}px)`)

	slider.find('.product-itm-dot').removeClass("active");
	slider.find('.product-itm-dot').eq(num).addClass("active");
}


const numRound = (num) => {
	return Math.round(num * 10) / 10
}

const calcRollWidth = (m) => {
	let percent = m / 9

	if (percent > 1) percent = 1;

	return percent * 6 + 5;
}

var resizeTimeout;

const product_slider_resize = () => {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(() => {
		$('.product-itm-images').each((i, itm) => {
			const num = parseInt($(itm).attr('data-page'));

			slider_move_to($(itm), num)
		})
	}, 500)

}

const product_slider_init = () => {
	$('.product-itm-images:not(.init)').each((i, self) => {
		const length = $(self).find(".product-itm-images__itm").length

		$(self).addClass('init');
		$(self).append('<div class="product-itm-images-dots"></div>')

		for (let i = 0; i < length; i++) {
			$(self).find('.product-itm-images-dots').append('<span class="product-itm-dot"></span>')
		}

		$(self).find('.product-itm-dot').first().addClass("active");
	})

	if ($(".catalog-slider__preview__img").length <= 2) {
		$('.catalog-slider__preview').addClass("small-items")
	}

	slider_preview = $('.catalog-slider__preview').owlCarousel({
		items: 3,
		margin: 24,
		dots: false,
		loop: $(".catalog-slider__preview__img").length > 2,
		nav: true,
		responsive: {
			0: {items: 1, margin: 8, dots: true},
			600: {items: 2, margin: 8, dots: true},
			1100: {items: 3, margin: 8, dots: false}
		},
	})
}

const priceFormat = (price) => {
	const formatter = new Intl.NumberFormat('ru-RU', {
		style: 'decimal',
		minimumFractionDigits: 0
	})

	return formatter.format(price);
}

const num_word = (value, words) => {
	value = Math.abs(value) % 100;
	var num = value % 10;
	if (value > 10 && value < 20) return words[2];
	if (num > 1 && num < 5) return words[1];
	if (num == 1) return words[0];
	return words[2];
}

const catalogFilterInit = () => {
	$('.bx-filter-parameters-box').each((k, i) => {
		let show = $(i).find('.switcher, .filter-itm:not(.disabled), .range-input-container').length > 0
		$(i).toggleClass('hide', !show);
	})
}